module.exports = ".locationpicker-loading {\n  width: 100%;\n  text-align: center;\n}\n\n.l-locationpicker-class {\n  position: relative;\n  display: inline-block;\n  overflow: hidden;\n  width: 100%;\n  height: 400px;\n}\n\n@media (max-width: 500px) {\n\n  .l-locationpicker-class {\n    height: 300px;\n  }\n\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/locationpicker.css
// module id = ./src/app/locationpicker.css
// module chunks = main